define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/Controller"
], function(declare,_,Controller) {

	return declare(Controller, {
		process: function() {
		    // summary: disable actions to protect against user clicking action twice while view is still loading
			var self = this;
			
		    this.disableActionView(true);
			this.setProgress();
			
			this.when(this.widget.queryMore(this.m_element),
				function() {
					self.postProcess(true)
				}
			);
		},
		
		postProcess: function(/*Boolean*/bStatus, /*Boolean*/bRepeat) {
			// summary: enable view actions and update view message
			this.inherited(arguments);
			this.widget.set("message");
			this.disableActionView(false);
		}
	});
});